import { useEffect, useRef } from "react";

/**
 * 브라우저·모바일 제스처 뒤로가기 1차 방어 (2026-08-21)
 *
 * ## 왜 필요한가
 *
 * 온보딩 위저드(`/wizard`)와 카드 등록 진입(`/payments?showCardReg=true`)은
 * **여러 단계를 한 URL 로 처리**한다. 그래서 뒤로가기는 "이전 단계" 가 아니라
 * **작업 바깥**(채널 목록·이전 화면)으로 나가고, 입력하던 값이 전부 사라진다.
 * 모바일에서는 화면 가장자리 스와이프로 의도 없이 발생하기 쉽다.
 *
 * ## 동작
 *
 * 1. 마운트 시 히스토리 항목을 하나 넣어둔다.
 * 2. 뒤로가기가 오면(`popstate`) **안내를 띄우고 항목을 다시 넣어** 현재 화면을 유지한다.
 * 3. **한 번 안내한 뒤에는 막지 않는다** — 정말 나가려는 사용자를 계속 붙잡으면 그것도 갇힌 것이다.
 *
 * ⚠️ 새로고침·탭 닫기는 이 방어 범위가 아니다(`beforeunload` 는 브라우저가 문구를 무시한다).
 * ⚠️ `index.js` 에 `StrictMode` 가 없어 effect 가 한 번만 실행된다 —
 *    도입되면 히스토리 항목이 두 개 쌓이므로 이 훅을 다시 검토해야 한다.
 *
 * @param {string} message 뒤로가기를 막았을 때 보여줄 안내
 * @param {boolean} [enabled=true] 특정 조건에서만 방어하고 싶을 때(예: 온보딩 진입 경로만)
 */
export default function useBackGuard(message, enabled = true) {
    const guardUsedRef = useRef(false);

    useEffect(() => {
        if (!enabled) return undefined;

        window.history.pushState({ omoplayBackGuard: true }, '');

        const handlePopState = () => {
            if (guardUsedRef.current) return;

            guardUsedRef.current = true;
            window.history.pushState({ omoplayBackGuard: true }, '');
            alert(message);
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [message, enabled]);
}
